import _ from 'lodash';

import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  REDIRECT_NOTIFICATION,
  USER_LOGOUT,
} from '../types';

const defaultState = {
  notify: {
    sound: null,
    message: null,
    show: false,
    location: 'bottom-center',
    action: null,
    actionLabel: null,
    actionPayload: {},
    showClose: false,
    type: null,
  },
};

const notify = (state = defaultState.notify, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      const updatedState = Object.assign({}, state);
      Object.keys(state).forEach((key) => {
        let value = state[key];
        if (_.has(action.payload, key)) {
          value = action.payload[key];
        }
        updatedState[key] = value;
      });
      return Object.assign({}, state, updatedState, {
        show: true,
      });
    }

    case HIDE_NOTIFICATION:
    case REDIRECT_NOTIFICATION:
      return Object.assign({}, state, {
        message: null,
        show: false,
      });

    case USER_LOGOUT:
      return Object.assign({}, defaultState.notify);

    default:
      return state;
  }
};

export default notify;



// WEBPACK FOOTER //
// ./src/state/reducers/notify.js